<template>
    <div class="alert-box">
        <div class="alert-body">
            <div class="alert-img">
                <img class="alert-img-one" :src='img' alt="" ref="bgimg"> 
                <img class="alert-img-toe" id="alert-img-toe" ref='img' :src='imgs' :style="top" alt="">
            </div>
            <div class="alert-hover" ref='echartsWrapper'>
                <div class="alert-hover-tips">{{tips}}</div>
                <div class="alert-button el-icon-s-grid" @touchstart.prevent='alerthover' @mousedown.prevent="alerthoverPC" ref='echartsWrappers'></div>
            </div>
            <!-- <div class="alert-operation">
               <span
               title="关闭验证码"
               @click="visiblefalse"
               class="el-icon-circle-close"
               ></span>
               <span
               title="刷新验证码"
               @click="canvasInit"
               class="el-icon-refresh-left"
               ></span>
              </div> -->
        </div>
    </div>
</template>

<script>
export default {
    name:'alert',
    data() {
        return{
            tips: "拖动左边滑块完成上方拼图",
            top:'',
            baifen:''
        }
    },
    props:['img','imgs','tops'],
    watch:{
        tops:function(newvel,old){
            this.top = `top:${newvel}`;
        }
    },
    methods:{
        visiblefalse(){
            this.$emit('visiblefalse',false);
        },
        canvasInit(){
            this.$emit('imgfundata');
        },
        alerthover(e){
            var dom = e.target;
            const downCoordinate = { x: e.touches[0].pageX, y: e.touches[0].pageY };
            let slider = document.querySelector("#alert-img-toe"); //滑块dom
            const eWidth = this.$refs.echartsWrapper.clientWidth;
            const eWidths = this.$refs.echartsWrappers.clientWidth;
            const imgwidth = this.$refs.img.clientWidth;
            var cur = ((eWidth+imgwidth)-eWidths)/100;
            var curs = (eWidth-eWidths)/100;
            let x = 0;
            let y = 0;
            var baifen = 0;
            var baifens = 0;
            var imgbaifen = 0;
            const move = moveEV => {
                x = moveEV.touches[0].pageX - downCoordinate.x;
                baifen = parseInt(x/cur);
                baifens = parseInt(x/curs);
                if(baifens>=0&&baifens<=100){
                  dom.style.left = x + "px";
                  slider.style.left =  x + "px"; 
                  this.baifen = baifen;
                }
            };
            const up = () => {
                document.removeEventListener("touchmove", move);
                document.removeEventListener("touchend", up);
                x = 0;
                dom.style.left = "";
                slider.style.left = "";
                this.$emit('loginfun',this.baifen);
            };
            document.addEventListener("touchmove", move);
            document.addEventListener("touchend", up);
            
        },
        alerthoverPC(e){
            var dom = e.target;
            const downCoordinate = { x: e.pageX, y: e.pageY };
            let slider = document.querySelector("#alert-img-toe"); //滑块dom
            const eWidth = this.$refs.echartsWrapper.clientWidth;
            const eWidths = this.$refs.echartsWrappers.clientWidth;
            const imgwidth = this.$refs.img.clientWidth;
            var cur = ((eWidth+imgwidth)-eWidths)/100;
            var curs = (eWidth-eWidths)/100;
            let x = 0;
            let y = 0;
            var baifen = 0;
            var baifens = 0;
            var imgbaifen = 0;
            const move = moveEV => {
                x = moveEV.pageX - downCoordinate.x;
                baifen = parseInt(x/cur);
                baifens = parseInt(x/curs);
                if(baifens>=0&&baifens<=100){
                    dom.style.left = x + "px";
                    slider.style.left =  x + "px";
                    this.baifen = baifen;
                }
            };
            const up = () => {
                document.removeEventListener("mousemove", move);
                document.removeEventListener("mouseup", up);
                x = 0;
                dom.style.left = "";
                slider.style.left = "";
                this.$emit('loginfun',this.baifen);
            };
            document.addEventListener("mousemove", move);
            document.addEventListener("mouseup", up);
        }
    },
    mounted(){
        let bgimgs = this.$refs.bgimg.clientWidth;
        let imgs = this.$refs.img.clientWidth;
    },
    created(){
        this.top = `top:${this.tops}`;
    }
}
</script>

<style scoped>
.alert-box{
    width:100%;
    height:100%;
    position: fixed;
    background:rgba(0, 0, 0, 0.7);
    z-index:999;
    top: 0;
    left: 0;
}
.alert-body{
    width:14rem;
    height:13rem;
    border:1px solid #ccc;
    background:#fff;
    position: absolute;
    top:50%;
    left:50%;
    transform:translate(-50%,-50%);
    border-radius:5px;
}
.alert-img{
    width:95%;
    margin-left:2.5%;
    margin-top:2.5%;
    margin-bottom:2.5%;
    height:64%;
    position: relative;
    overflow: hidden;
}
.alert-img-one{
    /* width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%; */
    width:100%;
    height:100%;
}
.alert-img-toe{
    position: absolute;
    left:0;
    z-index:999;
    width:2rem;
    height:1.8rem;
    /* width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%; */
}
.alert-hover{
    position: relative;
    width:95%;
    height:2.2rem;
    background:#f85415;
    margin-left:2.5%;
    border-radius:50px;
}
.alert-hover-tips{
    position: absolute;
    left:2.5rem;
    top:50%;
    font-size:.7rem;
    color: #fff;
    transform:translate(0,-50%);
}
.alert-button{
  position: absolute;
  width:2.2rem;
  height:2.2rem;
  background: #ffffff;
  box-shadow: #b9bdc8 0 0 3px;
  border-radius: 50%;
  font-size: 28px;
  color: #f85415;
  display:flex;
  justify-content:center;
  align-items:center;
  cursor: grab;
}
.alert-operation {
    margin-top:1%;
    width: 95%;
    margin-left:2.5%;
}
.alert-operation>span{
    color: #9fa3ac;
    display: inline-block;
    width: 40px;
    font-size: 25px;
    text-align: center;
 }
.alert-operation>span:hover {
    background: #e2e8f5;
}
</style>
